import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import type { ReactNode } from 'react';

interface AppDialogProps {
  open: boolean;
  onClose: () => void;
  buttons: ReactNode;
  title: string;
  message?: string;
  children?: ReactNode;
}

const AppDialog = ({ open, onClose, buttons, title, message, children }: AppDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-content"
    >
      <DialogTitle id="dialog-title">{title}</DialogTitle>
      <DialogContent>
        {message ? <DialogContentText id="dialog-content">{message}</DialogContentText> : <></>}
        {children ? children : <></>}
      </DialogContent>
      <DialogActions>{buttons}</DialogActions>
    </Dialog>
  );
};

export default AppDialog;
